import {
  FETCH_GRADE_BY_ID_START,
  FETCH_GRADE_BY_ID_SUCCESS,
  FETCH_GRADE_BY_ID_FAILED
} from '../../actionTypes/index.js'

import gradeAxios from '../../../../axios/gradeCriteria'
import { enqueueSnackbar } from '../../../actions/alert'

export const fetchGrade = gradeId => {
  return dispatch => {
    dispatch(fetchGradeByIdStart())
    gradeAxios
      .get(`${gradeId}`)
      .then(response => {
        if (response.status === 200) {
          const recordData = response.data.data
          dispatch(fetchGradeByIdSuccess(recordData))
        }
      })
      .catch(error => {
        console.log(error, { ...error })
        dispatch(fetchGradeByIdFailed())
        dispatch(
          enqueueSnackbar({
            message: 'Fetch Grade Failed',
            options: { variant: 'error' }
          })
        )
      })
  }
}

const fetchGradeByIdStart = () => {
  return {
    type: FETCH_GRADE_BY_ID_START
  }
}

const fetchGradeByIdSuccess = recordData => {
  return {
    type: FETCH_GRADE_BY_ID_SUCCESS,
    recordData
  }
}

const fetchGradeByIdFailed = () => {
  return {
    type: FETCH_GRADE_BY_ID_FAILED
  }
}
